import * as Routes from 'constants/Routes'

export default () => ({
  path: Routes.COOKIES,
  getComponent: async function (nextState, cb) {
    const module = await import('./CookiesContainer')
    cb(null, module.default)
  }
})
